<template>
	<div class="speech" :class="{ editing }" @click="onClick">
		<div ref="measure" class="speech__bubble speech__bubble--measure"></div>
		<div class="speech__bubble speech__bubble--visible">
			<span
				ref="editor"
				contenteditable
				class="speech__bubble__valign"
				@click="e => e.stopPropagation()"
				@focus="onFocus"
				@blur="onBlur"
				@input="onInput"
				>{{ value }}</span
			>
		</div>
		<div v-if="removable" class="speech__delete" @click="onDelete"></div>
	</div>
</template>

<script>
const MAX_LINES = 2
const LINE_HEIGHT = 22

export default {
	name: 'SpeechInput',
	props: {
		value: String,
		removable: Boolean
	},
	data() {
		return {
			editing: false
		}
	},
	methods: {
		// Text measuring
		getLines(text) {
			const { measure } = this.$refs

			// Set innerText and measure offsetHeight
			measure.innerText = text
			const lines = Math.ceil(measure.offsetHeight / LINE_HEIGHT)
			measure.innerText = ''
			return lines
		},
		fits(text) {
			return this.getLines(text) <= MAX_LINES
		},

		// User interaction
		setCursor() {
			const target = this.value.length
			if (target) {
				if (document.selection) {
					const sel = document.selection.createRange()
					sel.moveStart('character', target)
					sel.select()
				} else {
					const sel = window.getSelection()
					sel.collapse(this.$refs.editor.firstChild, target)
				}
			}
		},
		onClick() {
			this.$refs.editor.focus()
			this.setCursor()
		},
		onDelete(event) {
			event.stopPropagation()
			this.$emit('delete')
		},
		onFocus() {
			this.editing = true
			this.$refs.editor.innerText = ''
			this.$refs.editor.innerText = this.value
		},
		onBlur() {
			this.editing = false
		},
		onInput() {
			const text = this.$refs.editor.innerText
			if (this.fits(text)) {
				this.$emit('input', text)
			} else {
				this.$refs.editor.innerText = this.value
				this.setCursor()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@use "sass:math";
@import '~scss/components';

.speech {
	@include speech-bubble($center: false, $tail: false);
	cursor: text;
	flex-shrink: 0;

	&.editing &__bubble--visible {
		box-shadow: 0 0 0 2px $orange-95;
	}

	&__bubble__valign {
		outline: none;
		cursor: auto;
		min-width: 1px;

		&:empty:not(:focus)::after {
			content: 'Click to edit';
			font-weight: normal;
			opacity: 0.5;
		}
	}

	&__delete {
		$side: 0.75rem;
		$lw: 0.125rem;
		$offset: math.div(-1rem, 16);

		@include circle-button($side, $orange-95, $red-85);
		background-color: $orange-95;
		position: absolute;
		top: $offset;
		right: $offset;

		&::before,
		&::after {
			@extend %pseudo;
			width: $lw;
			height: $side;
			left: calc(50% - #{math.div($lw, 2)});
			top: calc(50% - #{math.div($side, 2)});
			background-color: $white;
		}
		&::before {
			transform: rotate(-45deg);
		}
		&::after {
			transform: rotate(45deg);
		}
	}
}
</style>
